// extracted by mini-css-extract-plugin
export default {"wTabs":"DetailedWrapper_wTabs__bkCLs","mt40":"DetailedWrapper_mt40__Wh8kj"};